import {dateTimeStringFromApiToDate, nullableDateTimeStringFromApiToDate, toDate} from "../../../../index";
import {
    GetUddannelsestypeTranslation,
    UddannelseTypeEnum
} from "../../../../core/sharedmodels/stilling/uddannelseTypeEnum";
import {
    GetStatusString,
    VejledersamtaleStatusEnum
} from "../../../vejledning/vejledersamtaler/VejledersamtaleStatusEnum";
import {
    DashboardUddannelsesplanStatusEnum,
    GetUddannelsesplanStatusString
} from "../../../vejledning/uddannelsesplan/DashboardUddannelsesplanStatusEnum";
import {Localizer} from "../../../../infrastructure/localization/localizer";
import {IdAndNameModel} from "../../../../core/sharedmodels/IdAndNameModel";

export class DashboardListForloebModel {
    brugerId: string
    forloebId: string
    brugernavn: string
    specialeNavn: string
    startDato: Date
    slutDato: Date
    uddannelsesstedNavn: string
    uddannelsestype: string
    evalueretDato?: Date
    evalueret: boolean
    godkendtDato?: Date
    godkendt: boolean
    fravaer: boolean
    introVejledersamtaleStatus: string
    justerendeVejledersamtaleStatus: string
    afsluttendeVejledersamtaleStatus: string
    dageSidenSidsteVejledersamtale?: number
    dageSidenSidsteUddannelsesplan?: number
    foersteUddannelsesplanStatus: string
    kompetenceProgress: number
    forloebProgress: number //hvor langt er brugeren inde i forløbet %-vis
    mdrOgDageTilbage: number[]
    vejlederNavne: string[]
    introSamtaleAfholdtDato?: string
    justerendeSamtaleAfholdtDato?: string
    afsluttendeSamtaleAfholdtDato?: string
    antalJusterendeVejledersamtaler: number
    antalUddannelsesplaner: number
    antalKlarmeldteKompetencer: number

    static Build(responseModel: DashboardListForloebResponseModel): DashboardListForloebModel {
        let model = new DashboardListForloebModel();
        model.brugerId = responseModel.brugerId;
        model.forloebId = responseModel.forloebId;
        model.brugernavn = responseModel.brugernavn;
        model.specialeNavn = responseModel.specialeNavn;
        model.fravaer = responseModel.fravaer;
        model.startDato = (dateTimeStringFromApiToDate(responseModel.startDato));
        model.slutDato = (dateTimeStringFromApiToDate(responseModel.slutDato));
        model.forloebProgress = ((new Date().getTime() - new Date(responseModel.startDato).getTime()) / (new Date(responseModel.slutDato).getTime() - new Date(responseModel.startDato).getTime()))*100;
        model.uddannelsestype = GetUddannelsestypeTranslation(responseModel.uddannelsestype as UddannelseTypeEnum, true);
        model.evalueretDato = nullableDateTimeStringFromApiToDate(responseModel.evalueretDato);
        model.evalueret = responseModel.evalueretDato !== undefined && responseModel.evalueretDato !== null;
        model.godkendtDato = nullableDateTimeStringFromApiToDate(responseModel.godkendtDato);
        model.godkendt = responseModel.godkendt;
        model.introVejledersamtaleStatus = GetStatusString(responseModel.introVejledersamtaleStatus);
        model.justerendeVejledersamtaleStatus = GetStatusString(responseModel.justerendeVejledersamtaleStatus);
        model.afsluttendeVejledersamtaleStatus = GetStatusString(responseModel.afsluttendeVejledersamtaleStatus);
        model.dageSidenSidsteVejledersamtale = responseModel.dageSidenSidsteVejledersamtale ?? undefined;
        model.dageSidenSidsteUddannelsesplan = responseModel.dageSidenSidsteUddannelsesplan ?? undefined;
        model.foersteUddannelsesplanStatus = GetUddannelsesplanStatusString(responseModel.foersteUddannelsesplanStatus);
        model.kompetenceProgress = responseModel.kompetenceProgress;
        model.uddannelsesstedNavn = responseModel.uddannelsesstedNavn;
        model.mdrOgDageTilbage = [getMonthsDifference(new Date(), toDate(responseModel.slutDato)), getDaysDifference(new Date().addMonths(getMonthsDifference(new Date(), toDate(responseModel.slutDato))), toDate(responseModel.slutDato))];
        model.vejlederNavne = responseModel.vejleder?.length > 0 ? responseModel.vejleder.map(v => v.name) : [Localizer.dashboard_tildelVejleder()];
        model.introSamtaleAfholdtDato = (nullableDateTimeStringFromApiToDate(responseModel.introSamtaleAfholdtDato))?.dateWithoutTimeFormat(true);
        model.justerendeSamtaleAfholdtDato = (nullableDateTimeStringFromApiToDate(responseModel.justerendeSamtaleAfholdtDato))?.dateWithoutTimeFormat(true);
        model.afsluttendeSamtaleAfholdtDato = (nullableDateTimeStringFromApiToDate(responseModel.afsluttendeSamtaleAfholdtDato))?.dateWithoutTimeFormat(true);
        model.antalJusterendeVejledersamtaler = responseModel.antalJusterendeVejledersamtaler;
        model.antalUddannelsesplaner = responseModel.antalUddannelsesplaner;
        model.antalKlarmeldteKompetencer = responseModel.antalKlarmeldteKompetencer;
        return model;
    }
}

export type DashboardListForloebResponseModel = {
    forloebId: string
    brugerId: string
    brugernavn: string
    specialeNavn: string
    specialeId: string
    uddannelsesstedNavn: string
    uddannelsestype: number
    uddannelseId: string
    evalueretDato?: string
    startDato: string
    slutDato: string
    godkendtDato?: string
    introVejledersamtaleStatus: VejledersamtaleStatusEnum
    justerendeVejledersamtaleStatus: VejledersamtaleStatusEnum
    afsluttendeVejledersamtaleStatus: VejledersamtaleStatusEnum
    dageSidenSidsteVejledersamtale?: number
    dageSidenSidsteUddannelsesplan?: number
    foersteUddannelsesplanStatus: DashboardUddannelsesplanStatusEnum
    godkendt: boolean
    fravaer: boolean
    kompetenceProgress: number
    vejleder: IdAndNameModel[]
    introSamtaleAfholdtDato?: string
    justerendeSamtaleAfholdtDato?: string
    afsluttendeSamtaleAfholdtDato?: string
    antalJusterendeVejledersamtaler: number
    antalUddannelsesplaner: number
    antalKlarmeldteKompetencer: number
}

function getMonthsDifference(startDate: Date, endDate: Date): number {
    const totalDaysDifference = getDaysDifference(startDate, endDate);
    if (totalDaysDifference < 30) {
        return 0;
    }
    const monthsApart = (endDate.getFullYear() - startDate.getFullYear()) * 12 + endDate.getMonth() - startDate.getMonth();
    return Math.abs(monthsApart);
}
function getDaysDifference(startDate: Date, endDate: Date): number {
    const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}
